import React from 'react';
import './contact.css'

const ContactUs = () => {
    return (
        <div className="container contact-container ">
            <div className="mt-5">
                <h3 className="pt-5">Phone no: 833-920-3234 , 888-675-7722</h3>
                <p > Email: cureItHospital@gmail.com</p>
                <p >Address: Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iusto qui optio reiciendis in </p>
            </div>
        </div>
    );
};

export default ContactUs;